import React from 'react';
import { Link } from 'react-router-dom';
import { XIcon, ShoppingBagIcon, TrashIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
interface CartPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
const CartPopup: React.FC<CartPopupProps> = ({
  isOpen,
  onClose
}) => {
  const {
    cartItems,
    removeFromCart,
    getTotalPrice
  } = useCart();
  if (!isOpen) return null;
  return <div className="absolute top-16 right-0 mt-2 w-80 bg-white rounded-lg shadow-xl z-50 overflow-hidden" data-id="element-57">
      <div className="p-4 border-b border-gray-100 flex justify-between items-center" data-id="element-58">
        <div className="flex items-center" data-id="element-59">
          <ShoppingBagIcon className="h-5 w-5 text-[#2e7d32] mr-2" data-id="element-60" />
          <h3 className="font-medium text-gray-900" data-id="element-61">Your Cart</h3>
          <span className="ml-2 bg-[#e8f5e9] text-[#2e7d32] text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-62">
            {cartItems.length} items
          </span>
        </div>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-63">
          <XIcon className="h-5 w-5" data-id="element-64" />
        </button>
      </div>
      {cartItems.length === 0 ? <div className="p-6 text-center" data-id="element-65">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 mb-4" data-id="element-66">
            <ShoppingBagIcon className="h-6 w-6 text-gray-400" data-id="element-67" />
          </div>
          <p className="text-gray-500 mb-4" data-id="element-68">Your cart is empty</p>
          <Link to="/products" onClick={onClose} className="inline-block text-[#2e7d32] font-medium hover:underline" data-id="element-69">
            Continue shopping
          </Link>
        </div> : <>
          <div className="max-h-60 overflow-y-auto p-4" data-id="element-70">
            {cartItems.map(item => <div key={item.product.id} className="flex items-center py-2 border-b border-gray-100 last:border-0" data-id="element-71">
                <div className="h-12 w-12 flex-shrink-0 overflow-hidden rounded-md border border-gray-200" data-id="element-72">
                  <img src={item.product.image} alt={item.product.name} className="h-full w-full object-cover object-center" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=150&auto=format&fit=crop';
            }} data-id="element-73" />
                </div>
                <div className="ml-4 flex-1" data-id="element-74">
                  <h4 className="text-sm font-medium text-gray-900 line-clamp-1" data-id="element-75">
                    {item.product.name}
                  </h4>
                  <p className="text-xs text-[#2e7d32]" data-id="element-76">{item.product.price}</p>
                </div>
                <button onClick={() => removeFromCart(item.product.id)} className="ml-2 text-gray-400 hover:text-red-500" data-id="element-77">
                  <TrashIcon className="h-4 w-4" data-id="element-78" />
                </button>
              </div>)}
          </div>
          <div className="p-4 border-t border-gray-100" data-id="element-79">
            <div className="flex justify-between items-center mb-4" data-id="element-80">
              <span className="text-sm font-medium text-gray-500" data-id="element-81">
                Subtotal
              </span>
              <span className="text-sm font-bold text-gray-900" data-id="element-82">
                KSh {getTotalPrice().toLocaleString()}
              </span>
            </div>
            <div className="space-y-2" data-id="element-83">
              <Link to="/cart" onClick={onClose} className="block w-full bg-[#2e7d32] text-white text-center py-2 rounded-lg hover:bg-[#1b5e20] transition-colors" data-id="element-84">
                View Cart
              </Link>
              <Link to="/checkout" onClick={onClose} className="block w-full bg-gray-100 text-gray-800 text-center py-2 rounded-lg hover:bg-gray-200 transition-colors" data-id="element-85">
                Checkout
              </Link>
            </div>
          </div>
        </>}
    </div>;
};
export default CartPopup;